"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaRematricula = exports.yupRematricula = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
const utils_1 = require("../utils");
const estado_1 = require("./estado");
exports.yupRematricula = yup.object({
    nome: yup
        .string()
        .required('Campo nome é obrigatório')
        .label('Nome do aluno')
        .max(65, 'Máximo de 65 caracteres.')
        .default(''),
    dataNasc: (0, utils_1.sge2Date)().label('Data de nascimento').nullable().default(null),
    sexo: yup.mixed().label('Sexo').oneOf(Object.values(enums_1.ESexo)).required().default(enums_1.ESexo.Feminino),
    localNascimento: yup.string().label('Local de Nascimento').max(30, 'Máximo de 30 caracteres.').default(''),
    estadoLocalNascimento: yup
        .string()
        .label('Estado local de nascimento')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    cpf: yup.string().label('CPF').max(15, 'Máximo de 15 caracteres.').default(''),
    rg: yup.string().label('RG').max(15, 'Máximo de 15 caracteres.').default(''),
    rgEstado: yup
        .string()
        .label('Estado RG')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    rgOrgaoExpedidor: yup.string().label('Orgão Expedidor').max(15, 'Máximo de 15 caracteres.').default(''),
    rgDataExpedicao: (0, utils_1.sge2Date)().label('Data expedição').nullable().default(null),
    estadoCivil: yup.mixed().label('Estado civil').default(enums_1.EEstadoCivil['Não Informado']),
    raca: yup.mixed().label('Raça').default(enums_1.ERaca['0 - Sem declaração']),
    email: yup
        .string()
        .label('E-mail')
        .email('Formato de e-mail inválido.')
        .default('')
        .max(60, 'Máximo de 60 caracteres.'),
    // login: yup.string().label('Login').max(20, 'Máximo de 20 caracteres.').default(''),
    // senha: yup.string().label('Senha').notRequired().max(15, 'Máximo de 15 caracteres.'),
    cep: yup.string().label('CEP').max(10, 'Máximo de 10 caracteres.').default(''),
    endereco: yup.string().label('Endereço').max(55, 'Máximo de 55 caracteres.').default(''),
    numero: yup.string().label('Número').max(5, 'Máximo de 5 caracteres.').default(''),
    apto: yup.string().label('Apartamento').max(15, 'Máximo de 15 caracteres.').default(''),
    bloco: yup.string().label('Bloco').max(15, 'Máximo de 15 caracteres.').default(''),
    bairro: yup.string().label('Bairro').max(35, 'Máximo de 35 caracteres.').default(''),
    cidade: yup.string().label('Cidade').max(30, 'Máximo de 30 caracteres.').default(''),
    estado: yup
        .string()
        .label('Estado')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    foneResidencial: yup.string().label('Telefone residencial').max(15, 'Máximo de 15 caracteres.').default(''),
    foneRecado: yup.string().label('Telefone recado').max(15, 'Máximo de 15 caracteres.').default(''),
    foneCelular: yup.string().label('Telefone celular').max(15, 'Máximo de 15 caracteres.').default(''),
    ramal: yup.string().label('Ramal').max(5, 'Máximo de 5 caracteres.').default(''),
    contato: yup.string().label('Contato').max(35, 'Máximo de 35 caracteres.').default(''),
    // tipoSanguineo: yup.mixed<ETipoSanguineo>().label('Tipo Sanguíneo').nullable().default(ETipoSanguineo.Nenhum),
    // alergia: yup.string().label('Tipo alergia').max(50, 'Máximo de 50 caracteres.').default(''),
    // nomeMedico: yup.string().label('Nome do Médico').max(40, 'Máximo de 40 caracteres.').default(''),
    // foneMedico: yup.string().label('Telefone do médico').max(15, 'Máximo de 15 caracteres.').default(''),
    // remedio: yup.string().label('Nome do remédio').max(50, 'Máximo de 50 caracteres.').default(''),
    // clinica: yup.string().label('Nome da clínica').max(50, 'Máximo de 50 caracteres.').default(''),
    // planoSaude: yup.string().label('Plano de saúde').max(50, 'Máximo de 50 caracteres.').default(''),
    // dataVacina: sge2Date().label('Data Vacina').nullable().default(null),
    nacionalidade: yup.string().label('Nacionalidade').max(15, 'Máximo de 15 caracteres.').default(''),
    escolaOrigem: yup.string().label('Escola de origem').max(80, 'Máximo de 80 caracteres.').default(''),
    estadoEscolaOrigem: yup
        .string()
        .label('Estado escola de origem')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    religiao: yup.string().label('Religião').max(20, 'Máximo de 20 caracteres.').default(''),
    certidaoNascimentoNova: yup.boolean().required().default(false).label('Certidão Novo Modelo'),
    certidaoNascimentoMatricula: yup
        .string()
        .label('Matrícula da certidão de nascimento')
        .max(100, 'Máximo de 100 caracteres.')
        .default(''),
    certidaoNascimento: yup.string().label('Certidão de nascimento').max(8, 'Máximo de 8 caracteres.').default(''),
    certidaoCartorio: yup.string().default('').max(100, 'Máximo de 100 caracteres.').label('Cartorio Certidão'),
    certidaoLivro: yup.string().default('').max(8).label('Livro Certidão'),
    certidaoFolha: yup.string().default('').max(6).label('Folha Certidão'),
    certidaoCidade: yup.string().default('').max(40).label('Cidade Certidão'),
    certidaoEstado: yup
        .string()
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(estado_1.estado[0].sigla)
        .label('Estado Certidão'),
    certidaoData: (0, utils_1.sge2Date)().default(null).nullable().label('Certidão Data'),
    // tipoResponsavel: yup
    //   .mixed<EAlunoTipoResp>()
    //   .label('Tipo responsável')
    //   .oneOf(Object.values(EAlunoTipoResp))
    //   .default(EAlunoTipoResp.Mae),
    guardaCompartilhada: yup.boolean().required().default(false).label('Guarda Compartilhada'),
    // --> Dados do Pai
    paiNome: yup.string().label('Nome').max(65, 'Máximo de 65 caracteres.').default(''),
    paiDataNascimento: (0, utils_1.sge2Date)().label('Data de nascimento').nullable().default(null),
    paiProfissao: yup.string().label('Profissão').max(150, 'Máximo de 150 caracteres.').default(''),
    paiTrabalho: yup.string().label('Local de trabalho').max(35, 'Máximo de 35 caracteres.').default(''),
    paiCpf: yup.string().label('CPF').max(15, 'Máximo de 15 caracteres.').default(''),
    paiRg: yup.string().label('RG').max(15, 'Máximo de 15 caracteres.').default(''),
    paiEstadoCivil: yup.mixed().label('Estado civil').default(enums_1.EEstadoCivil['Não Informado']),
    paiCep: yup.string().label('CEP').max(10, 'Máximo de 10 caracteres.').default(''),
    paiEndereco: yup.string().label('Endereço').max(55, 'Máximo de 55 caracteres.').default(''),
    paiNumero: yup.string().label('Número').max(5, 'Máximo de 5 caracteres.').default(''),
    paiApto: yup.string().label('Apartamento').max(15, 'Máximo de 15 caracteres.').default(''),
    paiBloco: yup.string().label('Bloco').max(15, 'Máximo de 15 caracteres.').default(''),
    paiBairro: yup.string().label('Bairro').max(35, 'Máximo de 35 caracteres.').default(''),
    paiCidade: yup.string().label('Cidade').max(30, 'Máximo de 30 caracteres.').default(''),
    paiEstado: yup
        .string()
        .label('Estado')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    paiFoneResidencial: yup.string().label('Telefone residencial').max(15, 'Máximo de 15 caracteres.').default(''),
    paiFoneRecado: yup.string().label('Telefone recado').max(15, 'Máximo de 15 caracteres.').default(''),
    paiFoneCelular: yup.string().label('Telefone celular').max(15, 'Máximo de 15 caracteres.').default(''),
    paiRamal: yup.string().label('Ramal').max(10, 'Máximo de 10 caracteres.').default(''),
    paiEmail: yup
        .string()
        .label('E-mail')
        .email('Formato de e-mail inválido.')
        .default('')
        .max(60, 'Máximo de 60 caracteres.'),
    paiReligiao: yup.string().label('Religião').max(20, 'Máximo de 20 caracteres.').default(''),
    paiFalecido: yup.bool().required().label('Falecido').default(false),
    paiDesaparecido: yup.bool().required().label('Desaparecido').default(false),
    // --> Dados do Mae
    maeNome: yup.string().label('Nome').max(65, 'Máximo de 65 caracteres.').default(''),
    maeDataNascimento: (0, utils_1.sge2Date)().label('Data de nascimento').nullable().default(null),
    maeProfissao: yup.string().label('Profissão').max(150, 'Máximo de 150 caracteres.').default(''),
    maeTrabalho: yup.string().label('Local de trabalho').max(35, 'Máximo de 35 caracteres.').default(''),
    maeCpf: yup.string().label('CPF').max(15, 'Máximo de 15 caracteres.').default(''),
    maeRg: yup.string().label('RG').max(15, 'Máximo de 15 caracteres.').default(''),
    maeEstadoCivil: yup.mixed().label('Estado civil').default(enums_1.EEstadoCivil['Não Informado']),
    maeCep: yup.string().label('CEP').max(10, 'Máximo de 10 caracteres.').default(''),
    maeEndereco: yup.string().label('Endereço').max(55, 'Máximo de 55 caracteres.').default(''),
    maeNumero: yup.string().label('Número').max(5, 'Máximo de 5 caracteres.').default(''),
    maeApto: yup.string().label('Apartamento').max(15, 'Máximo de 15 caracteres.').default(''),
    maeBloco: yup.string().label('Bloco').max(15, 'Máximo de 15 caracteres.').default(''),
    maeBairro: yup.string().label('Bairro').max(35, 'Máximo de 35 caracteres.').default(''),
    maeCidade: yup.string().label('Cidade').max(30, 'Máximo de 30 caracteres.').default(''),
    maeEstado: yup
        .string()
        .label('Estado')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    maeFoneResidencial: yup.string().label('Telefone residencial').max(15, 'Máximo de 15 caracteres.').default(''),
    maeFoneRecado: yup.string().label('Telefone recado').max(15, 'Máximo de 15 caracteres.').default(''),
    maeFoneCelular: yup.string().label('Telefone celular').max(15, 'Máximo de 15 caracteres.').default(''),
    maeRamal: yup.string().label('Ramal').max(10, 'Máximo de 10 caracteres.').default(''),
    maeEmail: yup
        .string()
        .label('E-mail')
        .email('Formato de e-mail inválido.')
        .default('')
        .max(60, 'Máximo de 60 caracteres.'),
    maeReligiao: yup.string().label('Religião').max(20, 'Máximo de 20 caracteres.').default(''),
    maeFalecido: yup.bool().required().label('Falecido').default(false),
    maeDesaparecido: yup.bool().required().label('Desaparecido').default(false),
    // --> Dados do Responsavel
    responsavelNome: yup.string().label('Nome').max(65, 'Máximo de 65 caracteres.').default(''),
    responsavelDataNascimento: (0, utils_1.sge2Date)().label('Data de nascimento').nullable().default(null),
    responsavelCpf: yup.string().label('CPF').max(15, 'Máximo de 15 caracteres.').default(''),
    responsavelRg: yup.string().label('RG').max(15, 'Máximo de 15 caracteres.').default(''),
    responsavelRgEstado: yup
        .string()
        .label('Estado RG')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    responsavelRgOrgaoExpedidor: yup.string().label('Orgão Expedidor').max(15, 'Máximo de 15 caracteres.').default(''),
    responsavelRgDataExpedicao: (0, utils_1.sge2Date)().label('Data expedição').nullable().default(null),
    responsavelNacionalidade: yup.string().default('').max(40, 'Máximo de 40 caracteres.').label('Nacionalidade'),
    responsavelNaturalidade: yup.string().default('').max(40, 'Máximo de 40 caracteres.').label('Naturalidade'),
    responsavelInstrucao: yup.string().default('').max(2).label('Nível de Instrução'),
    responsavelEstadoCivil: yup.mixed().label('Estado civil').default(enums_1.EEstadoCivil['Não Informado']),
    responsavelProfissao: yup.string().default('').max(150, 'Máximo de 150 caracteres.').label('Profissão'),
    responsavelTrabalho: yup.string().default('').max(35, 'Máximo de 35 caracteres.').label('Local de Trabalho'),
    responsavelPis: yup.string().default('').max(15, 'Máximo de 15 caracteres.').label('Pis'),
    responsavelRenda: yup.number().default(0).label('Renda Financeira'),
    responsavelDependentes: yup.number().default(0).label('Número Dependentes'),
    responsavelEmail: yup
        .string()
        .label('E-mail')
        .email('Formato de e-mail inválido.')
        .default('')
        .max(60, 'Máximo de 60 caracteres.'),
    responsavelCep: yup.string().label('CEP').max(10, 'Máximo de 10 caracteres.').default(''),
    responsavelCaixaPostal: yup.string().label('Caixa Postal').max(15, 'Máximo de 15 caracteres.').default(''),
    responsavelEndereco: yup.string().label('Endereço').max(55, 'Máximo de 55 caracteres.').default(''),
    responsavelNumero: yup.string().label('Número').max(5, 'Máximo de 5 caracteres.').default(''),
    responsavelApto: yup.string().label('Apartamento').max(5, 'Máximo de 5 caracteres.').default(''),
    responsavelBloco: yup.string().label('Bloco').max(15, 'Máximo de 15 caracteres.').default(''),
    responsavelBairro: yup.string().label('Bairro').max(35, 'Máximo de 35 caracteres.').default(''),
    responsavelCidade: yup.string().label('Cidade').max(30, 'Máximo de 30 caracteres.').default(''),
    responsavelEstado: yup
        .string()
        .label('Estado')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    responsavelFoneResidencial: yup
        .string()
        .label('Telefone residencial')
        .max(15, 'Máximo de 15 caracteres.')
        .default(''),
    responsavelFoneRecado: yup.string().label('Telefone recado').max(15, 'Máximo de 15 caracteres.').default(''),
    responsavelFoneCelular: yup.string().label('Telefone celular').max(15, 'Máximo de 15 caracteres.').default(''),
    responsavelRamal: yup.string().label('Ramal').max(5, 'Máximo de 5 caracteres.').default(''),
    responsavelCracha: yup.string().default('').max(15, 'Máximo de 15 caracteres.').label('Cracha'),
    responsavelReligiao: yup.string().default('').max(40, 'Máximo de 40 caracteres.').label('Religião'),
    responsavelNomePai: yup.string().default('').max(65, 'Máximo de 65 caracteres.').label('Nome do Pai'),
    responsavelNomeMae: yup.string().default('').max(65, 'Máximo de 65 caracteres.').label('Nome da Mãe'),
    // --> Dados do Fiador
    fiadorNome: yup.string().label('Nome').max(65, 'Máximo de 65 caracteres.').default(''),
    fiadorDataNascimento: (0, utils_1.sge2Date)().label('Data de nascimento').nullable().default(null),
    fiadorCpf: yup.string().label('CPF').max(15, 'Máximo de 15 caracteres.').default(''),
    fiadorRg: yup.string().label('RG').max(15, 'Máximo de 15 caracteres.').default(''),
    fiadorRgEstado: yup
        .string()
        .label('Estado RG')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    fiadorRgOrgaoExpedidor: yup.string().label('Orgão Expedidor').max(15, 'Máximo de 15 caracteres.').default(''),
    fiadorRgDataExpedicao: (0, utils_1.sge2Date)().label('Data expedição').nullable().default(null),
    fiadorNacionalidade: yup.string().default('').max(40, 'Máximo de 40 caracteres.').label('Nacionalidade'),
    fiadorNaturalidade: yup.string().default('').max(40, 'Máximo de 40 caracteres.').label('Naturalidade'),
    fiadorInstrucao: yup.string().default('').max(2).label('Nível de Instrução'),
    fiadorEstadoCivil: yup.mixed().label('Estado civil').default(enums_1.EEstadoCivil['Não Informado']),
    fiadorProfissao: yup.string().default('').max(150, 'Máximo de 150 caracteres.').label('Profissão'),
    fiadorTrabalho: yup.string().default('').max(35, 'Máximo de 35 caracteres.').label('Local de Trabalho'),
    fiadorPis: yup.string().default('').max(15, 'Máximo de 15 caracteres.').label('Pis'),
    fiadorRenda: yup.number().default(0).label('Renda Financeira'),
    fiadorDependentes: yup.number().default(0).label('Número Dependentes'),
    fiadorEmail: yup
        .string()
        .label('E-mail')
        .email('Formato de e-mail inválido.')
        .default('')
        .max(60, 'Máximo de 60 caracteres.'),
    fiadorCep: yup.string().label('CEP').max(10, 'Máximo de 10 caracteres.').default(''),
    fiadorCaixaPostal: yup.string().label('Caixa Postal').max(15, 'Máximo de 15 caracteres.').default(''),
    fiadorEndereco: yup.string().label('Endereço').max(55, 'Máximo de 55 caracteres.').default(''),
    fiadorNumero: yup.string().label('Número').max(5, 'Máximo de 5 caracteres.').default(''),
    fiadorApto: yup.string().label('Apartamento').max(5, 'Máximo de 5 caracteres.').default(''),
    fiadorBloco: yup.string().label('Bloco').max(15, 'Máximo de 15 caracteres.').default(''),
    fiadorBairro: yup.string().label('Bairro').max(35, 'Máximo de 35 caracteres.').default(''),
    fiadorCidade: yup.string().label('Cidade').max(30, 'Máximo de 30 caracteres.').default(''),
    fiadorEstado: yup
        .string()
        .label('Estado')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    fiadorFoneResidencial: yup.string().label('Telefone residencial').max(15, 'Máximo de 15 caracteres.').default(''),
    fiadorFoneRecado: yup.string().label('Telefone recado').max(15, 'Máximo de 15 caracteres.').default(''),
    fiadorFoneCelular: yup.string().label('Telefone celular').max(15, 'Máximo de 15 caracteres.').default(''),
    fiadorRamal: yup.string().label('Ramal').max(5, 'Máximo de 5 caracteres.').default(''),
    fiadorCracha: yup.string().default('').max(15, 'Máximo de 15 caracteres.').label('Cracha'),
    fiadorReligiao: yup.string().default('').max(40, 'Máximo de 40 caracteres.').label('Religião'),
    fiadorNomePai: yup.string().default('').max(65, 'Máximo de 65 caracteres.').label('Nome do Pai'),
    fiadorNomeMae: yup.string().default('').max(65, 'Máximo de 65 caracteres.').label('Nome da Mãe'),
    // --> Dados Financeiros
    // debitos: yup.number().min(0).default(0).label('Debitos'),
    mensalValorCurso: yup.number().min(0).default(0).label('Valor Curso'),
    mensalValorDesconto: yup.number().min(0).default(0).label('Valor Desconto'),
    mensalValorAnuidade: yup.number().min(0).default(0).label('Valor Anuidade'),
    mensalValorParcela: yup.number().min(0).default(0).label('Valor Parcela'),
    mensalNumeroParcela: yup.number().min(0).default(0).label('Numero Parcela'),
    mensalDiaVencimento: yup.number().min(0).default(0).label('Dia Vencimento'),
    materialValorTotal: yup.number().min(0).default(0).label('Valor Total Material'),
    materialValorDesconto: yup.number().min(0).default(0).label('Valor Desconto Material'),
    materialValorParcela: yup.number().min(0).default(0).label('Valor Parcela Material'),
    materialNumeroParcela: yup.number().min(0).default(0).label('Numero Parcela Material'),
    materialDiaVencimento: yup.number().min(0).default(0).label('Dia Vencimento Material'),
    // materialFormaPagamento: yup.number().min(0).default(0).label('Forma Pagamento Material'),
    // --> Outros Controles
    nomeSerie: yup.string().default('').label('Nome Serie'),
    turno: yup.mixed().oneOf(Object.values(enums_1.ETurno)).required().default(enums_1.ETurno.Manha).label('Turno'),
    grau: yup.string().default('').label('Nivel'),
    dataMatricula: (0, utils_1.sge2Date)().default(null).nullable().label('Data Matricula'),
    confirmado: yup.boolean().required().default(false).label('Matricula Confirmada'),
    rematriculado: yup.boolean().required().default(false).label('Rematriculado'),
    matriculou: yup.boolean().required().default(false).label('Matriculou'),
    aceite: yup.string().default('').max(500, 'Máximo de 500 caracteres.').label('Aceite'),
    autorizacaoSaida: yup
        .bool()
        .notRequired()
        .nullable()
        .label('O aluno esta autorizado a sair das dependências do colégio sozinho')
        .default(null),
    idCurso: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Curso'),
    idSerie: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Série'),
    idAluno: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Aluno'),
    idResponsavel: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Responsável'),
    idFiador: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Fiador'),
    idFpMaterial: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Forma de Pagamento Material'),
    idFpAnuidade: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Forma de Pagamento Anuidade'),
    idFpEntrada: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Forma de Pagamento Entrada'),
});
exports.schemaRematricula = exports.yupRematricula.shape({});
